<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>

    <b-container v-else>

        <b-container v-if="entity.PhotoList && entity.PhotoList.length"
                     class="mt-20">

            <b-row>
                <b-col v-for="(item, index) in entity.PhotoList" 
                       :key="index" 
                       class="p-15-0 center">

                    <div class="flipper">

                        <div class="front">
                            <b-img :src="item.Url" class="br-4" />
                        </div>

                        <div class="back">
                            <ul type="none" class="m-0 p-0">
                                <li class="h-center p-10">
                                    <a class="client-link" style="color: #86be44;" href="#" @click="openGalleryEdit(item)">Открыть</a>  
                                </li>
                                <li class="h-center">
                                    <a class="client-link" style="color: rgba(255, 0, 0, .5)" href="#" @click="deletePhotoDialog(item)">Удалить</a> 
                                </li>
                            </ul>
                        </div>

                    </div>

                </b-col>
            </b-row>
        </b-container>

        <b-container v-else class="mt-150">

            <b-row class="m-0 center">
                <b-img src="/img/photo-empty.png" class="ml-30"/>
            </b-row>

            <b-row class="center first-level">
                Здесь пока пусто
            </b-row>

            <b-row class="m-0 center second-level">
                Вы можете добавить фотографию
            </b-row>

        </b-container>

        <b-container> 
           
            <label for="input-photo">

                <b-img src="/img/btn-plus.png" 
                       class="button-plus" />

            </label>

            <input id="input-photo"
                   type="file" 
                   class="input-file" 
                   style="display: none;"
                   accept="image/jpeg,image/png"
                   @change="selectPhoto" />

        </b-container>

    </b-container>

</template>

<script>
import '@/assets/styles/client/gallery/gallery.css'

import apiService from "@/services/api.service"

import AllRoutes from '@/routes/all.routes'

import PhotoListModel from '@/store/models/client/gallery/PhotoList'
import PhotoModel from '@/store/models/client/gallery/Photo'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'
import dialogService from '@/services/dialog.service'

export default {
    data: function() {
        let load = new Loading();

        let auditId = this.$route.query.auditId;
        let formId = this.$route.query.formId;

        this.getGallery(load, auditId, formId);
        this.getAudit(load, auditId);
        this.getForm(load, auditId, formId);

        return {
            load: load,
            entity: null,
            selectedPhoto: null,

            audit: null,
            form: null
        }
    },
    methods: {
        getGallery: function(load, auditId, formId) {
            load.Calculate(true);

            apiService.Client.Gallery.GetGallery(auditId, formId)
                .then(response => {           
                    this.entity = new PhotoListModel().mapFromDto(response.data);   
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },

        getAudit: function(load, auditId) {
            load.Calculate(true);

            apiService.Client.Audit.Get(auditId)
                .then(response => {
                    this.audit = response.data;
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },

        getForm: function(load, auditId, formId) {
            load.Calculate(true);

            apiService.Client.Form.Get(auditId, formId)
                .then(response => {
                    this.form = response.data;
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },

        selectPhoto: function(event) {

            this.selectedPhoto = new PhotoModel(this.audit, this.form);

            this.onFileChange(event);
        },

        onFileChange: function(data) {
            var files = data.target.files || data.dataTransfer.files;
            this.selectedPhoto.FileName = files[0].name;

            this.downloadFile(files[0])
                    .then(e => {
                        this.selectedPhoto.Data = e.target.result;
                        this.$router.push({
                            name: AllRoutes.Client.Gallery.Edit,
                            params: { photo: this.selectedPhoto },
                            query: { auditId: this.audit.Id, formId: this.form.Id }
                        });
                    })
                    .catch(error => console.error(error));
        },

        downloadFile: function(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = resolve;
                reader.onerror = reject;
                reader.readAsDataURL(file);
            })
        },

        openGalleryEdit: function(photo) {
            this.$router.push( {
                name: AllRoutes.Client.Gallery.Edit,
                params: { photo: photo },
                query: { auditId: this.audit.Id, formId: this.form.Id, id: photo.Id  }
            });
        },
        
        deletePhotoDialog: function(photo) {
            dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данную фотографию?')
                .then(ok => {
                    this.deletePhoto(photo);
                })
                .catch(cancel => {});
        },
        deletePhoto: function(photo) {
            this.load.Calculate(true);

            apiService.Client.Gallery.PostDelete(this.audit.Id, this.form.Id, photo.Id)
                .then(response => {
                    this.$router.go(this.$router.currentRoute);
                })
                .catch(error => this.load.Calculate(false));
        }
    },
    components: {
        Spinner
    }
}
</script>